import { observer } from "mobx-react"

const Funding = observer(() => {
    return (<>
        <div className="container-fluid full-height d-flex">
            <div className="row flex-fill">
                {/* Buy Section */}
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center section-left p-3">
                    <h1 className="title text-center">COMMUNITY FUND</h1>
                    <p className="subtitle">
                        {" "}
                        Purpose: SnowballBoss dedicates a portion of every transaction to a community fund. This initiative empowers the community to support meaningful causes collectively while enjoying the platform's features.
                    </p>
                    <a className="btn-custom">
                        <i className="fas fa-arrow-up-right" />
                        COMMUNITY FUND
                    </a>
                    <div className="image-container">
                        <img
                            alt="Digital coin with glowing effects, representing blockchain"
                            src="assets/img/1.gif"
                            width={500}
                        />
                    </div>
                </div>
                {/* Sell Section */}
                <div className="col-md-6 d-flex flex-column justify-content-center align-items-center section-right p-3">
                    <h1 className="title text-center">MARKETING FUND</h1>
                    <p className="subtitle">
                        Purpose: Marketing plays a vital role in any memecoin’s success.
                        SnowballBoss dedicates part of each transaction to marketing
                        initiatives, ensuring the coin gains visibility and grows its user
                        base.
                    </p>
                    <a className="btn-custom">
                        <i className="fas fa-arrow-up-right" />
                        MARKETING FUND
                    </a>
                    <div className="image-container">
                        <img
                            alt="Blockchain network with digital coin symbols"
                            src="assets/img/2.gif"
                            width={500}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>)
});

export default Funding;